import {FC, useContext, useState} from 'react';
import {Controller, useForm} from 'react-hook-form';
import {useSetRecoilState} from 'recoil';

import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import {Box, Button, Divider, FormControl, MenuItem, Modal, Select, Stack, Toolbar, Typography} from '@mui/material';
import {EventBusContext} from '../../../providers/EventBus';
import {ServiceRequestService} from '../../../api/services/serviceRequest.service';
import {serviceRequestsQueryTrigger} from '../../../store/service-requests/atoms';
import {IReasonRejectionsDict} from '../../../shared/types/reasonRejectionsDict.types';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  width: 500,
  p: 2,
};

interface IServiceRequestRejectModal {
  open: boolean;
  handleClose: () => void;
  id: number;
  reasonRejections: IReasonRejectionsDict[];
}

export const ServiceRequestRejectModal: FC<IServiceRequestRejectModal> = ({
  open,
  handleClose,
  id,
  reasonRejections,
}) => {
  const {control, watch, getValues} = useForm<{code: string}>({
    defaultValues: {code: ''},
  });
  const [loading, setLoading] = useState(false);
  const triggerQuery = useSetRecoilState(serviceRequestsQueryTrigger);
  const {bus} = useContext(EventBusContext);

  const code = watch('code');

  const handleCreate = async () => {
    setLoading(true);

    const {code} = getValues();

    try {
      await ServiceRequestService.reject(id, code);

      triggerQuery((v) => v + 1);
      handleClose();
    } catch (err: any) {
      bus?.emit('error', [err]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open}>
      <Box sx={style}>
        <Toolbar
          sx={{
            pl: {sm: 1},
            pr: {xs: 1, sm: 1},
          }}
        >
          <Typography sx={{flex: '1 1 100%'}} variant="h6" id="formTitle" component="div">
            Выберите причину отмены заявки
          </Typography>
        </Toolbar>
        <Divider sx={{m: '10px 0'}} />
        <Stack direction="column" spacing={3} sx={{mt: 2}}>
          <Stack direction="column" spacing={1.5}>
            <Typography variant="body2">Причина отмены</Typography>
            <Controller
              control={control}
              name="code"
              render={({field: {value, onChange}}) => (
                <FormControl fullWidth>
                  <Select size="small" value={value} onChange={onChange}>
                    {reasonRejections.map((item) => (
                      <MenuItem value={item.code} key={item.code}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          </Stack>

          <Stack direction="row" sx={{justifyContent: 'space-between'}}>
            <Button variant="outlined" color="error" disabled={loading} onClick={handleClose}>
              Назад
            </Button>
            <LoadingButton
              color="primary"
              variant="contained"
              disabled={!code}
              onClick={() => handleCreate()}
              loading={loading}
            >
              Отменить заявку
            </LoadingButton>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};
